import styled from "styled-components";

import colors from "core/colors";

const SPINNER_COLOR = colors.midnight;

/* generated by https://loading.io/ */
export const StyledProcessingSpinner = styled.div`
    @keyframes ldio-nzxgsp1te9 {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .ldio-nzxgsp1te9 > div {
        animation: ldio-nzxgsp1te9 1s infinite linear;
        transform-origin: 50px 50px;
    }
    .ldio-nzxgsp1te9 > div div {
        position: absolute;
    }
    .ldio-nzxgsp1te9 > div div:nth-child(1),
    .ldio-nzxgsp1te9 > div div:nth-child(2) {
        width: 65px;
        height: 65px;
        border: 9px solid;
        border-radius: 50%;
        border-color: transparent ${SPINNER_COLOR} ${SPINNER_COLOR};
        box-sizing: border-box;
        position: absolute;
        transform: rotate(45deg);
        transform-origin: 50px 50px;
    }
    .ldio-nzxgsp1te9 > div div:nth-child(1) {
        transform: rotate(45deg) translate(17.5px, 17.5px);
    }
    .ldio-nzxgsp1te9 > div div:nth-child(2) {
        transform: rotate(0deg) translate(17.5px, 17.5px);
    }
    .ldio-nzxgsp1te9 > div div:nth-child(3) {
        width: 0;
        height: 0;
        border: 15px solid;
        border-color: transparent transparent transparent ${SPINNER_COLOR};
        transform: translate(50px, 10px);
    }
    & {
        width: 18px;
        height: 18px;
        display: inline-block;
        overflow: hidden;
        background: none;
    }
    .ldio-nzxgsp1te9 {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(0.18);
        backface-visibility: hidden;
        transform-origin: 0 0;
    }
    .ldio-nzxgsp1te9 div {
        box-sizing: content-box;
    }
`;
